/* eslint-disable global-require */
/* eslint-disable no-return-assign */
// eslint-disable-next-line import/no-cycle
// import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    showguide: false,
    animguide: true,
  },
  getters: {
    getShowGuide: state => state.showguide,
    getAnimGuide: state => state.animguide,
  },
  mutations: {
    SET_SHOW_GUIDE: (state, value) => (value ? (state.showguide = value) : (state.showguide = false)),
    SET_ANIM_GUIDE: (state, value) => (value ? (state.animguide = value) : (state.animguide = false)),
  },
  actions: {},
  modules: {},
}
